import styled from "styled-components";
import { breakpoints } from "styles";

export const RatingWrapper = styled.div`
  display: inline-grid;
  grid-template-areas:
    "label-start ."
    "rating rating"
    ". label-end";
  @media ${breakpoints.laptop} {
    grid-template-areas:
      "rating rating"
      "label-start label-end";
  }
`;

export const LabelEnd = styled.p`
  grid-area: label-end;
  text-align: right;
  color: ${({ theme }) => theme.colors.neutral["600"]};
  margin: 8px 0;
`;
export const LabelStart = styled.p`
  grid-area: label-start;
  color: ${({ theme }) => theme.colors.neutral["600"]};
  margin: 8px 0;
`;

export const RatingButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  grid-area: rating;
  flex-wrap: wrap;
`;
export const RatingWrap = styled.div`
  flex: 0 0 100%;
  @media ${breakpoints.laptop} {
    display: none;
  }
`;

export const RatingButton = styled.div<{ isSelected: boolean }>`
  border-radius: 50%;
  height: 48px;
  width: 48px;
  color: ${({ theme }) => theme.colors.white};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.xl};
  background: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.brand[500] : theme.colors.neutral[300]};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.primary};
`;
